import { render, staticRenderFns } from "./DefaultList.vue?vue&type=template&id=dbcf8828&scoped=true"
import script from "./DefaultList.vue?vue&type=script&lang=js"
export * from "./DefaultList.vue?vue&type=script&lang=js"
import style0 from "./DefaultList.vue?vue&type=style&index=0&id=dbcf8828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcf8828",
  null
  
)

export default component.exports